import forecastService from "@/api/forecast-api/forecast.service";

import { snackbar } from "@/core/controller/snackbar_controller";
import moment from "moment";

const state = {
  regionalForecast: [],
  regionalForecastDataLoading: false,
  agenciesForecast: [],
  agenciesForecastDataLoading: false,
  countiesForecast: [],
  countiesForecastDataLoading: false,
  countiesForecastAll: [],
  countiesPlotBands: [],
  countiesForecastHourlyAll: [],
  regionalForecastOverview: [],
  regionalForecastOverviewHourly: [],
  regionalForecastDataLoadingOverview: false,
  countiesForecastTableDetails: [],
  countiesForecastTableDetailsDataLoading: false,
  regionalForecastGraphic: [],
  dailyInterruptionsNotificationsRegional: [],
  dailyInterruptionsNotificationsAgency: [],
  dailyInterruptionsNotificationsCouties: [],
  regionalRealtimeData: [],
  regionalRealtimeDataDaily: [],

};

const mutations = {
  setRegionalForecast(state, data) {
    state.regionalForecast = data ? data : [];
  },
  setRegionalForecastDataLoading(state, data) {
    state.regionalForecastDataLoading = data;
  },
  setAgencyForecast(state, data) {
    state.agenciesForecast = data ? data : [];
  },
  setAgencyForecastDataLoading(state, data) {
    state.agenciesForecastDataLoading = data;
  },
  setCountiesForecast(state, data) {
    state.countiesForecast = data ? data : [];
  },
  setCountiesForecastDataLoading(state, data) {
    state.countiesForecastDataLoading = data;
  },
  setCountiesForecastAll(state, data) {
    state.countiesForecastAll = data ? data : [];
  },
  setCountiesForecastHourlyAll(state, data) {
    state.countiesForecastHourlyAll = data ? data : [];
  },
  setCountiesClassInterruptionAll(state, data) {
    state.countiesPlotBands = data ? data : [];
  },
  setRegionalForecastOverview(state, data) {
    state.regionalForecastOverview = data ? data : [];
  },
  setRegionalForecastOverviewHourly(state, data) {
    state.regionalForecastOverviewHourly = data ? data : [];
  },
  setRegionalForecastDataLoadingOverview(state, data) {
    state.regionalForecastDataLoadingOverview = data;
  },
  setCountiesForecastTableDetails(state, data) {
    state.countiesForecastTableDetails = data ? data : [];
  },
  setCountiesForecastTableDetailsDataLoading(state, data) {
    state.countiesForecastTableDetailsDataLoading = data;
  },
  setRegionalForecastGraphic(state, data) {
    state.regionalForecastGraphic = data ? data : [];
  },
  setDailyInterruptionNotificationsRegional(state, data) {
    state.dailyInterruptionsNotificationsRegional = data ? data : [];
  },
  setDailyInterruptionNotificationsAgency(state, data) {
    state.dailyInterruptionsNotificationsAgency = data ? data : [];
  },
  setDailyInterruptionNotificationsCouties(state, data) {
    state.dailyInterruptionsNotificationsCouties = data ? data : [];
  },
  setRegionalRealtimeData(state, data) {
    state.regionalRealtimeData = data ? data : [];
  },
  setRegionalRealtimeDataDaily(state, data) {
    state.regionalRealtimeDataDaily = data ? data : [];
  },

};

const actions = {
  async fetchRegionalForecast({ commit }, data) {
    const ids = [];
    data.locations.forEach((e) => ids.push(e.id));
    try {
      commit("setRegionalForecastDataLoading", true);
      const response = await forecastService.getRegionalForecast(
        ids,
        data.date
      );
      response.data.map((e) => {
        if (e.regionalId == 88) {
          e.fullname = "DOCCMN";
        }
        if (e.regionalId == 89) {
          e.fullname = "DOCCSL";
        }
        if (e.regionalId == 90) {
          e.fullname = "DOCMSL";
        }
        if (e.regionalId == 91) {
          e.fullname = "DOCNRO";
        }
        if (e.regionalId == 92) {
          e.fullname = "DOCNRT";
        }
        if (e.regionalId == 93) {
          e.fullname = "DOCOST";
        }
        if (e.regionalId == 94) {
          e.fullname = "DOCSUD";
        }
      });
      let reduced = Object.values(
        response.data.reduce((a, { fullname, ...props }) => {
          if (!a[fullname])
            a[fullname] = Object.assign({}, { fullname, data: [props] });
          else a[fullname].data.push(props);
          return a;
        }, [])
      );
      commit("setRegionalForecast", reduced);
    } catch (error) {
      commit("setRegionalForecast", undefined);
      snackbar.show({
        type: "error",
        title: "Falhou",
        message: error.message,
        timeout: 3000,
      });
    } finally {
      commit("setRegionalForecastDataLoading", false);
    }
  },
  async fetchRegionalForecastHourly({ commit }, data) {
    const ids = [];
    data.locations.forEach((e) => ids.push(e.id));
    try {
      commit("setRegionalForecastDataLoading", true);
      const response = await forecastService.getRegionalForecastHourly(
        ids,
        data.date
      );
      response.data.map((e) => {
        if (e.regionalId == 88) {
          e.fullname = "DOCCMN";
        }
        if (e.regionalId == 89) {
          e.fullname = "DOCCSL";
        }
        if (e.regionalId == 90) {
          e.fullname = "DOCMSL";
        }
        if (e.regionalId == 91) {
          e.fullname = "DOCNRO";
        }
        if (e.regionalId == 92) {
          e.fullname = "DOCNRT";
        }
        if (e.regionalId == 93) {
          e.fullname = "DOCOST";
        }
        if (e.regionalId == 94) {
          e.fullname = "DOCSUD";
        }
      });
      let reduced = Object.values(
        response.data.reduce((a, { fullname, ...props }) => {
          if (!a[fullname])
            a[fullname] = Object.assign({}, { fullname, data: [props] });
          else a[fullname].data.push(props);
          return a;
        }, [])
      );
      commit("setRegionalForecast", reduced);
    } catch (error) {
      commit("setRegionalForecast", undefined);
      snackbar.show({
        type: "error",
        title: "Falhou",
        message: error.message,
        timeout: 3000,
      });
    } finally {
      commit("setRegionalForecastDataLoading", false);
    }
  },

  async fetchAgencyForecast({ commit }, data) {
    const ids = [];
    data.locations.forEach((e) => ids.push(e.id));
    try {
      commit("setAgencyForecastDataLoading", true);
      const response = await forecastService.getAgencyForecast(ids, data.date);
      let reduced = Object.values(
        response.data.reduce((a, { agencyIds, ...props }) => {
          if (!a[agencyIds[0]])
            a[agencyIds[0]] = Object.assign(
              {},
              { agency: agencyIds[0], data: [props] }
            );
          else a[agencyIds[0]].data.push(props);
          return a;
        }, [])
      );
      commit("setAgencyForecast", reduced);
    } catch (error) {
      commit("setAgencyForecast", undefined);
      snackbar.show({
        type: "error",
        title: "Falhou",
        message: error.message,
        timeout: 3000,
      });
    } finally {
      commit("setAgencyForecastDataLoading", false);
    }
  },
  async fetchAgencyForecastHourly({ commit }, data) {
    const ids = [];
    data.locations.forEach((e) => ids.push(e.id));
    try {
      commit("setAgencyForecastDataLoading", true);
      const response = await forecastService.getAgencyForecastHourly(
        ids,
        data.date
      );
      let reduced = Object.values(
        response.data.reduce((a, { agencyIds, ...props }) => {
          if (!a[agencyIds[0]])
            a[agencyIds[0]] = Object.assign(
              {},
              { agency: agencyIds[0], data: [props] }
            );
          else a[agencyIds[0]].data.push(props);
          return a;
        }, [])
      );
      commit("setAgencyForecast", reduced);
    } catch (error) {
      commit("setAgencyForecast", undefined);
      snackbar.show({
        type: "error",
        title: "Falhou",
        message: error.message,
        timeout: 3000,
      });
    } finally {
      commit("setAgencyForecastDataLoading", false);
    }
  },
  async fetchCountieForecast({ commit }, data) {
    const ids = [];
    data.locations.forEach((e) => ids.push(e.cityId));
    commit("setCountiesForecastDataLoading", true);
    const response = await forecastService.getCountieForecast(ids, data.date);
    commit("setCountiesForecast", response.data);
    commit("setCountiesForecastDataLoading", false);
  },
  async fetchCountieForecastHourly({ commit }, data) {
    const ids = [];
    data.locations.forEach((e) => ids.push(e.cityId));
    commit("setCountiesForecastDataLoading", true);
    const response = await forecastService.getCountieForecastHourly(
      ids,
      data.date
    );
    commit("setCountiesForecast", response.data);
    commit("setCountiesForecastDataLoading", false);
  },

  async fetchCountieForecastAll({ commit }, data) {
    try {
      const ids = [];

      data.locations.forEach((e) => ids.push(e.cityId));
      commit("setCountiesForecastDataLoading", true);
      const response = await forecastService.getCountieForecastAll(ids);
      const responseHourly = await forecastService.getCountieForecastHourlyAll(
        ids
      );
      commit("setCountiesForecastAll", response.data);
      commit("setCountiesForecastHourlyAll", responseHourly.data);
    } catch (error) {
      commit("setCountiesForecastHourlyAll", undefined);
      commit("setCountiesForecastAll", undefined);
      snackbar.show({
        type: "error",
        title: "Falhou",
        message: error.message,
        timeout: 3000,
      });
    } finally {
      commit("setCountiesForecastDataLoading", false);
    }
  },

  async fetchRegionalForecastOverview({ commit }, data) {
    try {
      commit("setRegionalForecastDataLoadingOverview", true);
      const response = await forecastService.getRegionalForecastOverview(
        data.date
      );

      response.data.map((e) => {
        if (e.regionalId == 88) {
          e.fullname = "DOCCMN";
          e.icon = "";
        }
        if (e.regionalId == 89) {
          e.fullname = "DOCCSL";
          e.icon = "";
        }
        if (e.regionalId == 90) {
          e.fullname = "DOCMSL";
          e.icon = "";
        }
        if (e.regionalId == 91) {
          e.fullname = "DOCNRO";
          e.icon = "";
        }
        if (e.regionalId == 92) {
          e.fullname = "DOCNRT";
          e.icon = "";
        }
        if (e.regionalId == 93) {
          e.fullname = "DOCOST";
          e.icon = "";
        }
        if (e.regionalId == 94) {
          e.fullname = "DOCSUD";
          e.icon = "";
        }
      });
      const sortedData = response.data.sort(
        (a, b) => b.sumStartRegional - a.sumStartRegional
      );
      commit("setRegionalForecastOverview", sortedData);
    } catch (error) {
      commit("setRegionalForecastOverview", undefined);
      snackbar.show({
        type: "error",
        title: "Falhou",
        message: error.message,
        timeout: 3000,
      });
    } finally {
      commit("setRegionalForecastDataLoadingOverview", false);
    }
  },
  async fetchRegionalForecastOverviewHourly({ commit }, data) {
    try {
      commit("setRegionalForecastDataLoadingOverview", true);
      const response = await forecastService.getRegionalForecastHourlyOverview(
        data.date
      );
      response.data.map((e) => {
        if (e.regionalId == 88) {
          e.fullname = "DOCCMN";
          e.icon = "";
        }
        if (e.regionalId == 89) {
          e.fullname = "DOCCSL";
          e.icon = "";
        }
        if (e.regionalId == 90) {
          e.fullname = "DOCMSL";
          e.icon = "";
        }
        if (e.regionalId == 91) {
          e.fullname = "DOCNRO";
          e.icon = "";
        }
        if (e.regionalId == 92) {
          e.fullname = "DOCNRT";
          e.icon = "";
        }
        if (e.regionalId == 93) {
          e.fullname = "DOCOST";
          e.icon = "";
        }
        if (e.regionalId == 94) {
          e.fullname = "DOCSUD";
          e.icon = "";
        }
      });
      const sortedData = response.data.sort(
        (a, b) => b.sumStartRegional - a.sumStartRegional
      );
      commit("setRegionalForecastOverviewHourly", sortedData);
    } catch (error) {
      commit("setRegionalForecastOverviewHourly", undefined);
      snackbar.show({
        type: "error",
        title: "Falhou",
        message: error.message,
        timeout: 3000,
      });
    } finally {
      commit("setRegionalForecastDataLoadingOverview", false);
    }
  },

  async fetchRegionalForecastGraphicHourly({ commit }, data) {
    try {
      commit("setRegionalForecastDataLoadingOverview", true);
      const response = await forecastService.getRegionalForecastHourlyGraphic(
        data.date
      );

      response.data.map((e) => {
        if (e.regionalId == 88) {
          e.fullname = "DOCCMN";
          e.icon = "";
        }
        if (e.regionalId == 89) {
          e.fullname = "DOCCSL";
          e.icon = "";
        }
        if (e.regionalId == 90) {
          e.fullname = "DOCMSL";
          e.icon = "";
        }
        if (e.regionalId == 91) {
          e.fullname = "DOCNRO";
          e.icon = "";
        }
        if (e.regionalId == 92) {
          e.fullname = "DOCNRT";
          e.icon = "";
        }
        if (e.regionalId == 93) {
          e.fullname = "DOCOST";
          e.icon = "";
        }
        if (e.regionalId == 94) {
          e.fullname = "DOCSUD";
          e.icon = "";
        }
      });

      commit("setRegionalForecastGraphic", response.data);
    } catch (error) {
      commit("setRegionalForecastGraphic", undefined);
      snackbar.show({
        type: "error",
        title: "Falhou",
        message: error.message,
        timeout: 3000,
      });
    } finally {
      commit("setRegionalForecastDataLoadingOverview", false);
    }
  },

  async fetchRegionalForecastGraphicDaily({ commit }, data) {
    try {
      commit("setRegionalForecastDataLoadingOverview", true);
      const response = await forecastService.getRegionalForecastDailyGraphic(
        data.date
      );

      response.data.map((e) => {
        if (e.regionalId == 88) {
          e.fullname = "DOCCMN";
        }
        if (e.regionalId == 89) {
          e.fullname = "DOCCSL";
        }
        if (e.regionalId == 90) {
          e.fullname = "DOCMSL";
        }
        if (e.regionalId == 91) {
          e.fullname = "DOCNRO";
        }
        if (e.regionalId == 92) {
          e.fullname = "DOCNRT";
        }
        if (e.regionalId == 93) {
          e.fullname = "DOCOST";
        }
        if (e.regionalId == 94) {
          e.fullname = "DOCSUD";
        }
      });
      commit("setRegionalForecastGraphic", response.data);
    } catch (error) {
      commit("setRegionalForecastGraphic", undefined);
      snackbar.show({
        type: "error",
        title: "Falhou",
        message: error.message,
        timeout: 3000,
      });
    } finally {
      commit("setRegionalForecastDataLoadingOverview", false);
    }
  },

  async fetchCountieForecastTableDetails({ commit }, data) {
    const ids = [];
    data.locations.forEach((e) => ids.push(e.cityId));
    commit("setCountiesForecastTableDetailsDataLoading", true);
    try {
      const payload = {
        date: data.date,
        locationIds: ids,
      };
      const response = await forecastService.getCountiesForecastDetailsTable(
        payload
      );
      let id = 1;
      response.data.map((el) => {
        el.agency = el.agencyIds ? el.agencyIds[0] : null;
        el.agencyName = "";
        el.id = id;
        id++;
        if (el.cistart) {
          el.ci = `${el.cistart} a ${el.cistop} (CI)`;
        } else {
          el.ci = "";
        }
        //create windRange propertie
        if (el.windGust <= 40) {
          el.windRange = "Fraco";
        }
        if (el.windGust > 40 && el.windGust <= 55) {
          el.windRange = "Moderado";
        }
        if (el.windGust > 55 && el.windGust <= 70) {
          el.windRange = "Forte";
        }
        if (el.windGust > 70 && el.windGust <= 90) {
          el.windRange = "Intenso";
        }
        if (el.windGust > 90) {
          el.windRange = "Extremo";
        }
        //create rainRange propertie
        if (el.precIntensity >= 155) {
          el.rainRange = "Extrema";
        }
        if (el.precIntensity >= 105 && el.precIntensity < 155) {
          el.rainRange = "Intensa";
        }
        if (el.precIntensity >= 55 && el.precIntensity < 105) {
          el.rainRange = "Forte";
        }
        if (el.precIntensity >= 40 && el.precIntensity < 55) {
          el.rainRange = "Moderada";
        }
        if (el.precIntensity >= 15 && el.precIntensity < 40) {
          el.rainRange = "Elevada";
        }
        if (el.precIntensity < 15) {
          el.rainRange = "Sem alerta";
        }
        //create ciRange propertie
        if (el.outageResult == "high") {
          el.ciRange = "Alto";
        }
        if (el.outageResult == "medium") {
          el.ciRange = "Médio";
        }
        if (el.outageResult == "low") {
          el.ciRange = "Baixo";
        }
        if (el.outageResult == "zero") {
          el.ciRange = "Nulo";
        }
        if (!el.outageResult) {
          el.ciRange = "Nulo";
        }
      });
      commit("setCountiesForecastTableDetails", response.data);
    } catch (error) {
      commit("setCountiesForecastTableDetails", []);
      snackbar.show({
        type: "error",
        title: "Falhou",
        message: error.message,
        timeout: 3000,
      });
    } finally {
      commit("setCountiesForecastTableDetailsDataLoading", false);
    }
  },

  async fetchCountieForecastTableDetailsHourly({ commit }, data) {
    const ids = [];
    data.locations.forEach((e) => ids.push(e.cityId));
    commit("setCountiesForecastTableDetailsDataLoading", true);
    try {
      const payload = {
        datetime: data.date,
        locationIds: ids,
      };
      const response =
        await forecastService.getCountiesForecastHourlyDetailsTable(payload);
      let id = 1;
      response.data.map((el) => {
        el.agency = el.agencyIds ? el.agencyIds[0] : null;
        el.agencyName = "";
        el.id = id;
        id++;
        if (el.cistart) {
          el.ci = `${el.cistart} a ${el.cistop} (CI)`;
        } else {
          el.ci = "";
        }
        if (el.outageResult == "high") {
          el.ci = `acima de ${el.cistart} (CI)`;
        }
        //create windRange propertie
        if (el.windGust <= 40) {
          el.windRange = "Fraco";
        }
        if (el.windGust > 40 && el.windGust <= 55) {
          el.windRange = "Moderado";
        }
        if (el.windGust > 55 && el.windGust <= 70) {
          el.windRange = "Forte";
        }
        if (el.windGust > 70 && el.windGust <= 90) {
          el.windRange = "Intenso";
        }
        if (el.windGust > 90) {
          el.windRange = "Extremo";
        }
        //create rainRange propertie
        if (el.precIntensity >= 55) {
          el.rainRange = "Extrema";
        }
        if (el.precIntensity >= 38 && el.precIntensity < 55) {
          el.rainRange = "Intensa";
        }
        if (el.precIntensity >= 20 && el.precIntensity < 38) {
          el.rainRange = "Forte";
        }
        if (el.precIntensity >= 8.4 && el.precIntensity < 20) {
          el.rainRange = "Moderada";
        }
        if (el.precIntensity < 8.4) {
          el.rainRange = "Sem alerta";
        }
        //create ciRange propertie
        if (el.outageResult == "high") {
          el.ciRange = "Alto";
        }
        if (el.outageResult == "medium") {
          el.ciRange = "Médio";
        }
        if (el.outageResult == "low") {
          el.ciRange = "Baixo";
        }
        if (el.outageResult == "zero") {
          el.ciRange = "Nulo";
        }
        if (!el.outageResult) {
          el.ciRange = "Nulo";
        }
      });
      commit("setCountiesForecastTableDetails", response.data);
    } catch (error) {
      commit("setCountiesForecastTableDetails", []);
      snackbar.show({
        type: "error",
        title: "Falhou",
        message: error.message,
        timeout: 3000,
      });
    } finally {
      commit("setCountiesForecastTableDetailsDataLoading", false);
    }
  },
  async fetchDailyInterruptionRegionalNotifications({ commit, rootState }) {
    const payload = {
      regionalIds: [],
      results: ["min", "max"],
      startDate: moment().add(1, "days").format("YYYY-MM-DD"),
      endDate: moment().add(1, "days").format("YYYY-MM-DD"),
    };
    const userPreferencesNotification = rootState.User.userConfigs;
    try {
      if (userPreferencesNotification && userPreferencesNotification?.favoriteRegionalNotifications) {
        payload.regionalIds = userPreferencesNotification.favoriteRegionalIds;

        const payloadHourly = {
          regionalIds: userPreferencesNotification.favoriteRegionalIds,
          datetime: moment().format(),
        };

        const [response, responseHourly] = await Promise.all([
          forecastService.getDailyInterruptionsForNotifications(payload),
          forecastService.getHourly34RegionalSumInterruptions(payloadHourly),
        ]);
        response.data.map((e) => {
          if (e.regionalId == 88) {
            e.fullname = "DOCCMN";
          }
          if (e.regionalId == 89) {
            e.fullname = "DOCCSL";
          }
          if (e.regionalId == 90) {
            e.fullname = "DOCMSL";
          }
          if (e.regionalId == 91) {
            e.fullname = "DOCNRO";
          }
          if (e.regionalId == 92) {
            e.fullname = "DOCNRT";
          }
          if (e.regionalId == 93) {
            e.fullname = "DOCOST";
          }
          if (e.regionalId == 94) {
            e.fullname = "DOCSUD";
          }
        });
        let reduced = Object.values(
          response.data.reduce((a, { fullname, ...props }) => {
            if (!a[fullname])
              a[fullname] = Object.assign({}, { fullname, data: [props] });
            else a[fullname].data.push(props);
            return a;
          }, [])
        );

        const max3hPorRegional = {};
        if (responseHourly && responseHourly.data) {
          responseHourly.data.forEach((item) => {
            const regionalName = item.regional;
            const value = item.result;
            if (
              !max3hPorRegional[regionalName] ||
              value > max3hPorRegional[regionalName]
            ) {
              max3hPorRegional[regionalName] = value;
            }
          });
        }

        reduced.map((regional) => {
          regional.max3h = max3hPorRegional[regional.fullname] || 0;

          regional.highAlert = 0;
          regional.mediumAlert = 0;
          regional.data.map((el) => {
            if (el.result >= 5000) {
              regional.highAlert++;
            }
            else if (el.result > 50) {
              regional.mediumAlert++;
            }
          });
        });
        commit("setDailyInterruptionNotificationsRegional", reduced);
      } else {
        commit("setDailyInterruptionNotificationsRegional", []);
      }
    } catch (error) {
      commit("setDailyInterruptionNotificationsRegional", []);
      snackbar.show({
        type: "error",
        title: "Falhou",
        message: error.message,
        timeout: 3000,
      });
    }
  },
  async fetchDailyInterruptionAgencyNotifications({ commit, rootState }) {
    const payload = {
      agencyIds: [],
      results: ["min", "max"],
      startDate: moment().add(1, "days").format("YYYY-MM-DD"),
      endDate: moment().add(1, "days").format("YYYY-MM-DD"),
    };
    const userPreferencesNotification = rootState.User.userConfigs;
    try {
      if (userPreferencesNotification && userPreferencesNotification?.favoriteAgencyNotifications) {
        payload.agencyIds = userPreferencesNotification.favoriteAgencyIds;
        const response =
          await forecastService.getDailyInterruptionsForNotifications(payload);
        let reduced = Object.values(
          response.data.reduce((a, { agencyIds, ...props }) => {
            if (!a[agencyIds[0]])
              a[agencyIds[0]] = Object.assign({}, { agencyIds, data: [props] });
            else a[agencyIds[0]].data.push(props);
            return a;
          }, [])
        );
        reduced.map((e) => {
          e.highAlert = 0;
          e.mediumAlert = 0;
          e.data.map((el) => {
            if (el.result == "high") {
              e.highAlert++;
            }
            if (el.result == "medium") {
              e.mediumAlert++;
            }
          });
        });
        commit("setDailyInterruptionNotificationsAgency", reduced);
      } else {
        commit("setDailyInterruptionNotificationsAgency", []);
      }
    } catch (error) {
      commit("setDailyInterruptionNotificationsAgency", []);
      snackbar.show({
        type: "error",
        title: "Falhou",
        message: error.message,
        timeout: 3000,
      });
    }
  },
  async fetchDailyInterruptionCountieNotifications({ commit, rootState }) {
    const payload = {
      locationIds: [],
      results: ["min", "max"],
      startDate: moment().add(1, "days").format("YYYY-MM-DD"),
      endDate: moment().add(1, "days").format("YYYY-MM-DD"),
    };
    const userPreferencesNotification = rootState.User.userConfigs;
    try {
      if (userPreferencesNotification && userPreferencesNotification?.favoriteCityNotifications) {
        payload.locationIds = userPreferencesNotification.favoriteCityIds;
        const response =
          await forecastService.getDailyInterruptionsForNotifications(payload);
        commit("setDailyInterruptionNotificationsCouties", response.data);
      } else {
        commit("setDailyInterruptionNotificationsCouties", []);
      }
    } catch (error) {
      commit("setDailyInterruptionNotificationsCouties", []);
      snackbar.show({
        type: "error",
        title: "Falhou",
        message: error.message,
        timeout: 3000,
      });
    }
  },

  async fetchRegionalRealtimeData({ commit }, date) {
    const { fetchRegionalGeoServerData } = await import("@/helpers/geojson_ci_maps");
    try {
      const data = await fetchRegionalGeoServerData(date);
      commit("setRegionalRealtimeData", data);
    } catch (error) {
      console.error('[Vuex Action] Erro ao buscar dados do GeoServer:', error);
      commit("setRegionalRealtimeData", []);
      snackbar.show({
        type: "error",
        title: "Falhou",
        message: error.message,
        timeout: 3000,
      });
    }
  },
  async fetchRegionalRealtimeDataDaily({ commit }, date) {
    const { fetchRegionalGeoServerDataDaily } = await import("@/helpers/geojson_ci_maps");
    try {
      const data = await fetchRegionalGeoServerDataDaily(date);
      commit("setRegionalRealtimeDataDaily", data);
    } catch (error) {
      console.error('[Vuex Action Daily] Erro ao buscar dados do GeoServer:', error);
      commit("setRegionalRealtimeDataDaily", []);
      snackbar.show({
        type: "error",
        title: "Falhou",
        message: error.message,
        timeout: 3000,
      });
    }
  },


};

const getters = {
  regionalForecastData: (state) => state.regionalForecast,
  regionalForecastDataLoading: (state) => state.regionalForecastDataLoading,
  agencyForecastData: (state) => state.agenciesForecast,
  agenciesForecastDataLoading: (state) => state.agenciesForecastDataLoading,
  countiesForecastData: (state) => state.countiesForecast,
  countiesForecastDataLoading: (state) => state.countiesForecastDataLoading,
  countiesForecastDataAll: (state) => state.countiesForecastAll,
  countiesForecastDataHourlyAll: (state) => state.countiesForecastHourlyAll,
  regionalForecastDataOverview: (state) => state.regionalForecastOverview,
  regionalForecastDataOverviewHourly: (state) =>
    state.regionalForecastOverviewHourly,
  regionalForecastDataLoadingOverview: (state) =>
    state.regionalForecastDataLoadingOverview,
  regionalForecastDataGraphic: (state) => state.regionalForecastGraphic,
  countiesForecastTableDetails: (state) => state.countiesForecastTableDetails,
  countiesForecastTableDetailsDataLoading: (state) =>
    state.countiesForecastTableDetailsDataLoading,
  dailyInterruptionsNotificationsRegionalData: (state) =>
    state.dailyInterruptionsNotificationsRegional,
  dailyInterruptionsNotificationsAgencyData: (state) =>
    state.dailyInterruptionsNotificationsAgency,
  dailyInterruptionsNotificationsCoutiesData: (state) =>
    state.dailyInterruptionsNotificationsCouties,
  regionalRealtimeData: (state) => state.regionalRealtimeData,
  regionalRealtimeDataDaily: (state) => state.regionalRealtimeDataDaily,
};

export default {
  state,
  mutations,
  actions,
  getters,
};
